import React, { useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Alert } from "../";
import { AllWidgets } from "./";
import { DeviceSection } from "../../context/DeviceContext";
import { deviceJoin, deviceWidgetsJoinedApi, zoneWidgets } from "../../api";
import { setDeviceWidgetsJoined, setZoneWidgets } from "../../redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiCheck, FiArrowLeft, FiList, FiCpu } from "react-icons/fi";

const AllDeviceComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const deviceWidgets = useSelector((state) => state.deviceWidgets);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const deviceJoinFunc = () => {
    const formData = new FormData();
    const serial = deviceWidgets[0]?.["serial"];
    formData.append("serial", serial);
    formData.append("zone", dashboardZones[0]?.["id"]);
    deviceJoin(formData, token)
      .then(() => {
        const data = new FormData();
        data.append("serial", serial);
        deviceWidgetsJoinedApi(data, token)
          .then((res) => {
            dispatch(setDeviceWidgetsJoined(res.data.data));
            ShowHideDeviceFunction("widgetsJoined");
            const zoneId = new FormData();
            zoneId.append("zone", dashboardZones[0]?.["id"]);
            zoneWidgets(zoneId, token)
              .then((res) => {
                dispatch(setZoneWidgets(res.data.data));
              })
              .catch((err) => {
                if (err.response.status === 403) {
                  Cookies.remove("token");
                  props.history.push("/login");
                  setShowAlert({
                    show: true,
                    message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
                    type: "Error",
                  });
                  setTimeout(() => {
                    setShowAlert((prev) => ({ ...prev, show: false }));
                  }, 2000);
                }
              });
          })
          .catch((err) => {
            if (err.response.status === 403) {
              Cookies.remove("token");
              props.history.push("/login");
              setShowAlert({
                show: true,
                message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
                type: "Error",
              });
              setTimeout(() => {
                setShowAlert((prev) => ({ ...prev, show: false }));
              }, 2000);
            }
          });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else {
          setShowAlert({
            show: true,
            message: t("این دستگاه قبلا اضافه شده است."),
            type: "Error",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 3000);
        }
      });
  };

  const closeAlert = () => {
    setShowAlert(prev => ({ ...prev, show: false }));
  };

  return (
    <div className="all-device-container">
      {/* Header */}


      {/* Devices List */}
      <div className="all-device-list">
        {deviceWidgets?.map((widget, index) => {
          return <AllWidgets key={index} widget={widget} num={index + 1} />;
        })}
      </div>

      {/* Action Buttons */}
      <div className="setting-buttons">
        <button
          type="button"
          className="setting-back-btn"
          onClick={() => ShowHideDeviceFunction("scanDevice")}
          style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
        >
          <FiArrowLeft size={18} />
          <span>{t("بازگشت")}</span>
        </button>
        <button
          type="button"
          className="setting-back-btn"
          onClick={deviceJoinFunc}
        >
          <FiCheck size={18} />
          <span>{t("تائید")}</span>
        </button>
      </div>

      {showAlert.show && (
        <Alert 
          message={showAlert.message} 
          type={showAlert.type}
          toggleAlert={closeAlert}
        />
      )}
    </div>
  );
};

const AllDevice = withRouter(AllDeviceComp);

export { AllDevice };